/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VisualizzazioneTipoPratica } from './visualizzazione-tipo-pratica';


export interface TipoPraticaPatchForm { 
    version: number;
    visualizzazione?: VisualizzazioneTipoPratica;
    titolo?: string;
    descrizione?: string;
    data_apertura?: string;
    data_chiusura?: string;
    data_pubblicazione_graduatoria?: string;
    data_riferimento_avviso?: string;
    url_documentazione?: string;
    configurazione_form_cittadino?: any | null;
    configurazione_form_esercente?: any | null;
}



